import { render, staticRenderFns } from "./inventoryXAContrast.vue?vue&type=template&id=08383d78&scoped=true"
import script from "./inventoryXAContrast.vue?vue&type=script&lang=js"
export * from "./inventoryXAContrast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08383d78",
  null
  
)

export default component.exports